import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
    Input,
    AutoComplete,
    Button,
    /* Checkbox, */ /* DatePicker, *//*  Spin, */ /* message, */ Tooltip,
    Select,
} from 'antd';
import "./EmailAutoComplete.scss";
import intl from 'react-intl-universal';

import userIcon from '@/assets/Collaboration/user.svg';
import loadingIcon from '@/assets/Collaboration/loading.svg'
import { store } from 'Store/store.index';
import { inject, observer } from 'mobx-react';
import { COLLABORATION_INVITE_EMAIL_MSG_LIMIT } from '@/limit.constant';
import { bindBeforeCreateShareLinkOrSendShareEmail } from '@/modules/dingtalk/lazy-load';

const { Option } = AutoComplete;
const { TextArea } = Input;

/**
 * @function changeAllowComment
 * @function send
 * @param {boolean} loading 

 */
@inject('appStore', 'userStore', 'accountStore', 'historyStore')
@observer
class EmailAutoComplete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            AllowComment: this.getAllowComment(),
            emailList: [],
            options: [],
            selectEmailList: [],
            email: '',
            disabledSend: false,
            textAreaMsg: '',
        }
    }
    getAllowComment() {
        const { canComment } = store.collaborationStore
        
        if (!canComment || this.props.docProhibitComment === 1) {
            return false
        }
        
        return true
    }
    async componentDidMount() {
        const memberList =  !!this.props.memberList?this.props.memberList.map(item=>{return {email:item.email,userName:item.userName}}):[];
        const result = await store.collaborationStore.getShareRelationship()
        let emailList = result.data[0].userList.map(item => {
            if (!item.userName) {
                item.userName = ''
            }
            return item
        })
        let newList = emailList.filter((item)=>{
            return  !memberList.some(i=>i.email == item.email)
        })
        this.setState({
            emailList:newList,
        })
    }
    changeAllowComment = (isList, index, value, email) => {
        if (isList) {
            let { selectEmailList } = this.state;
            selectEmailList[index].AllowComment = !!value;
            if (value == '2') {
                this.deleceEmailItem(email)
                return
            }
            this.setState({ selectEmailList })
        } else {
            this.setState({ AllowComment: !!value }, () => {
            })
        }
        this.props.changeAllowComment(value)
    }
    onSearch = (searchText) => {
        let options = []
            options = this.state.emailList.filter(item => {
                if(item.email.indexOf(searchText) != -1 && item.email != searchText){
                    return true
                }
            }).map(item => {
                return { value: `${item.email}`,name:`${item.userName}` }
            })
            options.unshift({ value: `${searchText}` })

        this.setState({ options })
    };
    onSelect = (data) => {
        const { selectEmailList, AllowComment } = this.state;
        this.props.form.validateFields((err/*, values*/) => {
            if (!err) {
                let result = selectEmailList.some(item => item.email == data);
                if (!result) {
                    selectEmailList.push({
                        email: data,
                        AllowComment
                    })
                    this.setState({ selectEmailList, email: '', disabledSend: false })
                    const { resetFields } = this.props.form;
                    resetFields();
                }
            }
        });

       
    }
    deleceEmailItem = (email) => {
        let emailList = [...this.state.selectEmailList]
        this.setState({ selectEmailList: emailList.filter(item => item.email !== email) })
        this.props.form.resetFields()
        this.props.form.setFieldsValue({email: ''})
    }
    renderSelectAfter = (isList, index, AllowComment, email) => {
        let isDisabled = false
        let AllowCommentValue = AllowComment ? 1 : 0;
        const { canComment } = store.collaborationStore
        
        if (!canComment || this.props.docProhibitComment === 1) {
            AllowCommentValue = 0
            isDisabled = true
        }

        return (
            <Select className="comment-authority-select" /* getPopupContainer={triggerNode => triggerNode.parentNode} */ value={AllowCommentValue} style={{ width: 140 }} onChange={(value) => { this.changeAllowComment(isList, index, value, email) }}>
                <Option value={1} disabled={ isDisabled }>{intl.get('shareDlg.SharedFileLink.canComment')}</Option>
                <Option value={0}>{intl.get('shareDlg.SharedFileLink.canView')}</Option>
                {isList && <Option value={2}>{intl.get('shareDlg.SharedFileLink.Remove')}</Option>}
            </Select>
        )
    };
    getOption = () => {
        const { options } = this.state;
        const optionsAuto = options.filter(item=>item.value!='').map((item, /* index */) => {
            return (
                <Option key={`${item.value}`} value={`${item.value}`}>
                    <div className='wrapUser'>
                        <img src={userIcon} alt="" />
                        <div>
                            {item.name&&<p>{item.name}</p>}
                            <p>{item.value}</p>
                        </div>
                    </div>
                </Option>
            )
        })
        return optionsAuto;
    }
    send = () => {
        const { AllowComment, emailList, options, selectEmailList, email, textAreaMsg: message } = this.state;

        if (message.length > COLLABORATION_INVITE_EMAIL_MSG_LIMIT) {
            store.appStore.setGlobalMessage({type: 'error', content: intl.get('shareDlg.errorMessage.moreThanLimitLength', {limitLength: COLLABORATION_INVITE_EMAIL_MSG_LIMIT})})

            return
        }

        this.props.send({ AllowComment, emailList, options, selectEmailList, email, message});
        this.reset()
    }
    reset =()=>{
        this.setState({ email: '',  selectEmailList:[], options: [], textAreaMsg: ''})

        const { resetFields } = this.props.form;

        resetFields();
    }
    onFocus = () => {
        this.setState({
            disabledSend: true
        })
    }
    onBlur = () => {
        this.setState({
            disabledSend: false
        })
    }
    onChangeEmail = (value) => {
        let { disabledSend } = this.state;
        if (disabledSend) {
            if (value.length == 0) {
                disabledSend = false
            }
        }
        if (!disabledSend) {
            if (value.length > 0) {
                disabledSend = true
            }
        }
        this.setState({ disabledSend })
    }
    validateEmail = (rule, value, callback) => {
        const { selectEmailList } = this.state;
        const memberList =  !!this.props.memberList?this.props.memberList.map(item=>{return {email:item.email,userName:item.userName}}):[];
        const isHas = selectEmailList.some(item => {
        if (item.email == value) {
        return true
        }
    })
    const isSend  = memberList.some(item =>{
        if(item.email == value){
            return true
        }
    })
    const reg = /[\u4E00-\u9FA5]/;
    const isCN = reg.test(value);
    if (value) {
        if (isHas || isSend) {
        callback(intl.get('collaboration.sharedList.Error.emailExists'))
        }if(isCN){
        callback(intl.get('collaboration.sharedList.Error.email'))
        }else {
        callback()
        }
    } else {
        callback()
    }

    };
    onChangeTextAreaMsg = (event) => {
        const value = event.target.value

        this.setState({
            textAreaMsg: value,
        })
    }
    render() {
        const { loading } = this.props
        const { AllowComment, selectEmailList, /* options */ disabledSend, textAreaMsg } = this.state
        const { getFieldDecorator } = this.props.form;
        
        return (
            <div className='wrap_autoComplete'>
                {!loading && <div >
                    <div className='autoCompleteContainer'>
                        <Form>
                            <Form.Item className="email-input">
                                {getFieldDecorator('email', {
                                    rules: [
                                        {
                                            type: 'email',
                                            message: intl.get('collaboration.sharedList.Error.email'),
                                        },
                                        {
                                            validator: this.validateEmail
                                        },
                                    ],
                                    validateTrigger: ['onChange', 'onFocus']
                                })(
                                    <AutoComplete className="email-auto-complete" optionLabelProp='value' dropdownClassName='dropdownShareWithEmail' getPopupContainer={triggerNode => triggerNode.parentNode} onSelect={this.onSelect} onSearch={this.onSearch} onChange={this.onChangeEmail} /* allowClear */
                                        placeholder={intl.get('shareDlg.ShareWithEmail.searchPlaceholder')} dataSource={this.getOption()} onFocus={this.onFocus} onBlur={this.onBlur}>
                                    </AutoComplete>
                                )}
                            </Form.Item>
                        </Form>
                        {this.renderSelectAfter(false, 0, AllowComment)}
                    </div>
                    <div className={'emailContentBox online-scroll-bar'}>
                        <ul className={'emailListBox'}>
                            {selectEmailList.map((item, index) => {
                                return (
                                    <li className={'emailItemBox'} key={index}>
                                        <span>
                                            <span className="wrapEmail">
                                                <Tooltip placement="top" title={item.email}>
                                                    <span> {item.email}</span>
                                                </Tooltip>
                                            </span>
                                            {/* <span className='closeIcon' onClick={() => { this.deleceEmailItem(item.email) }}>x</span> */}
                                        </span>
                                        {this.renderSelectAfter(true, index, item.AllowComment, item.email)}
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                    <TextArea className="message-text-area" placeholder={intl.get('shareDlg.ShareWithEmail.addInfo')} value={textAreaMsg} onChange={this.onChangeTextAreaMsg} />
                </div>}

                {loading && <div className="loadingBox">
                    <div className="loadingBoxRight">
                        <img className="loadingIcon" src={loadingIcon} alt="" />
                        <div>
                            <p>{intl.get('shareDlg.SharedFileLink.waitTitle')}</p>
                            <span className='waitText'>{intl.get('shareDlg.SharedFileLink.waitText')}</span>
                        </div>
                    </div>
                </div>}
                <Button disabled={loading || disabledSend || selectEmailList.length == 0} className="createBtn" type="primary" shape="round" onClick={bindBeforeCreateShareLinkOrSendShareEmail(this.send)}>{intl.get('shareDlg.ShareWithEmail.sendBtnText')}</Button>

            </div>
        )
    }
}
const WrapEmailAutoComplete = Form.create({ name: 'EmailAutoComplete' })(EmailAutoComplete);
export default WrapEmailAutoComplete